<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/delivery/details/', projectId, deliveryId, jobId]">Zurück zum Lieferschein</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Lieferschein {{ projectId }}.0004.{{ deliveryId }} bearbeiten</h2>
  <app-delivery-form
    *ngIf="delivery"
    [projectId]="projectId"
    [jobId]="jobId"
    [deliveryId]="deliveryId"
    [deliveryData]="delivery[0]"
    [isUpdateMode]="true">
  </app-delivery-form>
</main>
